
























































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    inheritAttrs: false,
})
export default class CEditDialog extends Vue {
    @Prop({default: false, type: Boolean}) value!: boolean;
    @Prop({default: false, type: Boolean}) loading!: boolean;
    @Prop({default: false, type: Boolean}) saving!: boolean;
    @Prop() okBtnText!: string;
    @Prop() cancelBtnText!: string;
    @Prop() commonErrors!: Array<string> | null;

    onClickOutside() {
        const focusable = Array.from(document.querySelectorAll('.v-dialog__content'));
        const active = focusable.find(el => el.classList.contains('v-dialog__content--active'));
        active && (active as HTMLElement).focus();
    }

    get commonErrorsText() {
        if (this.commonErrors && this.commonErrors.length > 0) {
            let slice = this.commonErrors.slice(1);
            return `${this.commonErrors[0]}` + ` ${slice.length > 0 ? `+${slice.length}` : ''}`;
        }
        return '';
    }
}
